/*  React  */
import React from 'react';

/*  Components  */
import Headers from '../Components/Table/Headers';

/*  Functions  */
import Helpers from './Functions';

/*  Constants  */
const { isset } = Helpers;

class TableHeaders {
    constructor({ t, theme, defaults = {} }) {
        this.t = t;
        this.defaults = defaults;
        this.theme = theme;
    }

    make = (headers) => {
        const { t, theme } = this;

        return headers.map((h) => {
            const param = h[0];
            let name = '';

            let options = h[1] || {};
            if (Helpers.isObject(param)) {
                options = param;
            } else {
                name = param;
            }

            const HeaderWithTheme = Headers(theme);

            if (isset(h, 'component')) {
                const { component } = h;

                if (isset(HeaderWithTheme, component)) {
                    const header = HeaderWithTheme[component];
                    options = { ...header, ...h };
                    name = header.name;
                }
            }

            const { key, renderCheckbox } = options;
            const sortableKey = key || options.sortableKey;
            const field = sortableKey || options.field;
            const align = options.align || 'left';

            let renderHeader = <strong>{t(name)}</strong>;
            if (renderCheckbox) {
                renderHeader = renderCheckbox;
            }

            return {
                ...this.defaults,
                ...options,
                align,
                field,
                renderHeader,
                sortableKey
            };
        });
    };
}

export default TableHeaders;
